export default {"src":"/pro/_next/static/media/vertex-logo.33fe983c.svg","height":28,"width":145,"blurWidth":0,"blurHeight":0};